import { CartItem } from '@/api/backend/contract/Cart';

import { GTMItemListName } from '../lib/types';

import { sanitizeGTMString } from './sanitizeGTMString';

export type CartEcommerceItem = {
  item: CartItem;
  quantity?: number;
  position?: number;
  itemListName?: GTMItemListName;
  isFullRemove?: boolean;
};

export function mapCartGTMItem(source: CartEcommerceItem, index: number) {
  const { item, quantity, position, itemListName, isFullRemove } = source;

  return {
    item_id: item.product.sku || '',
    item_name: sanitizeGTMString(item.product.name),
    price: Number(item.price || 0),
    item_brand: '',
    item_category: sanitizeGTMString(item.product.category?.name),
    item_category2: 'none',
    variant: item.size || '',
    position: (position ? position - 1 : index) + 1,
    quantity: quantity ?? item.quantity,
    item_list_name: itemListName || 'cart',
    cart_item_uuid: item.uuid,
    is_full_remove: isFullRemove
  };
}
